
import { ENonConformiteType } from "src/app/domain/enum/non-conformite-type";
import { ENotificationFrequency } from "src/app/domain/enum/notification-frequency";
import { ESampleStatus } from "src/app/domain/enum/sample-status";
import { EUserRole } from "src/app/domain/enum/user-role";
import { NonConformite } from "src/app/domain/non-conformite";
import { EOrderStatus } from "src/app/domain/order-status";

export class StringConverter {

    static getUserTypeName(status: EUserRole) {
        switch (status) {
            case EUserRole.Gestionnaire:
                return 'Gestionnaire';
            case EUserRole.Technicien:
                return 'Technicien';
            default:
                return 'Not Set';
        }
    }

    static getNotificationFrequencyLabel(f: ENotificationFrequency) {
        switch (f) {
            case ENotificationFrequency.Instantane:
                return 'Instantané';
            case ENotificationFrequency.Journalier:
                return 'Journalier';
            case ENotificationFrequency.Favori:
                return 'Favori';
            default:
                return 'Not Set';
        }
    }

    static getNonConformiteName(type: ENonConformiteType) {
        switch (type) {
            case ENonConformiteType.AReception:
                return 'A reception';
            case ENonConformiteType.EnCoursdAnalyse:
                return 'En cours d\'analyse';
            default:
                return 'Not Set';
        }
    }

    static getSampleStatusName(status: ESampleStatus) {
        switch (status) {
            case ESampleStatus.Code:
                return 'Codé';
            case ESampleStatus.Confirme:
                return 'Confirmé';
            case ESampleStatus.EnMesure:
                return 'En mesure';
            case ESampleStatus.Valide:
                return 'Validé';
            default:
                return 'Not Set';
        }
    }

    static getOrderStatusNameForMEL(status: EOrderStatus) {
        switch (status) {
            case EOrderStatus.AttenteReception:
                return 'En attente de réception';
            case EOrderStatus.Receptionne:
                return 'Commandes réceptionnées';
            case EOrderStatus.AnalyseEncours:
                return 'Prise en charge labo';
            case EOrderStatus.NCEnCours:
                return 'Non-conformités';
            case EOrderStatus.Termine:
                return 'Validé';
            default:
                return 'Not Set';
        }
    }

    static getOrderStatusNameForEAB(status: EOrderStatus) {
        switch (status) {
            case EOrderStatus.AttenteReception:
                return 'En transit';
            case EOrderStatus.Receptionne:
                return 'Commandes réceptionnées';
            case EOrderStatus.AnalyseEncours:
                return 'Prise en charge labo';
            case EOrderStatus.NCEnCours:
                return 'Non-conformités';
            default:
                return 'Not Set';
        }
    }
    // static getReclamationTypeList(): string[] {
    //     return Object.values(EReclamationType).filter(x => (typeof x === 'string')) as string[];
    // }

}
